import { Breadcrumb, Tab } from '@fukuri-admins/ui/common';
import { StressAssessmentAnswerTable } from '../../StressAssessmentAnswerTable';
import { StressAssessmentProfile } from '../../StressAssessmentProfile';
import { TAB_ITEMS } from '../constants';
import type { BreadcrumbItem } from '../types';
import styles from './styles.module.scss';
import { YourCondition } from './YourCondition';

type Props = {
  stressAssessmentId: string;
  userName: string;
  breadcrumbItems: BreadcrumbItem[];
  selectedTab: string;
  onTabChange: (value: string) => void;
  // 評価結果タブ用
  result: React.ComponentProps<typeof StressAssessmentProfile>['result'];
  // 回答結果タブ用
  answers: React.ComponentProps<typeof StressAssessmentAnswerTable>['answers'];
  // カテゴリー
  categories: React.ComponentProps<typeof StressAssessmentAnswerTable>['categories'];
};

export const StressAssessmentUserResultPresentation: React.FC<Props> = ({
  userName,
  breadcrumbItems,
  selectedTab,
  onTabChange,
  result,
  answers,
  categories,
}) => {
  return (
    <div className={styles.container}>
      <Breadcrumb items={breadcrumbItems} />

      <h1 className={styles.pageTitle}>{userName ? `${userName}さんの調査結果` : '調査結果'}</h1>

      <Tab items={TAB_ITEMS} defaultSelectedValue={selectedTab} onClick={onTabChange} />

      <div className={styles.content}>
        {selectedTab === 'assessment' && (
          <div className={styles.assessmentTab}>
            <YourCondition
              isHighStress={result.is_high_stress ?? false}
              guidanceText={result.guidance_text ?? ''}
            />
            <StressAssessmentProfile result={result} />
          </div>
        )}

        {selectedTab === 'answers' && (
          <div className={styles.answersTab}>
            <StressAssessmentAnswerTable answers={answers} categories={categories} />
          </div>
        )}
      </div>
    </div>
  );
};
